// spec/frontend/access-map.md: frontend-access-map-R01/R02; rbac-R01/R04/R11/R43.
// No role, project membership, or edit suffix implies another privilege.
export const PRIVILEGES = [
  'metabridge.projects.view', 'metabridge.projects.edit',
  'metabridge.sources.view', 'metabridge.sources.edit', 'metabridge.sources.run',
  'metabridge.exploration.view', 'metabridge.exploration.edit',
  'metabridge.project_dictionaries.manage', 'metabridge.model.view', 'metabridge.model.edit',
  'metabridge.versions.view', 'metabridge.versions.edit', 'metabridge.versions.merge_main',
  'metabridge.mappings.view', 'metabridge.mappings.edit',
  'metabridge.datamarts.view', 'metabridge.datamarts.edit',
  'metabridge.mdm.view', 'metabridge.mdm.edit', 'metabridge.databridge.view', 'metabridge.databridge.edit',
  'metabridge.comments.view', 'metabridge.comments.create', 'metabridge.comments.edit_others',
  'metabridge.trash.restore', 'metabridge.publication.export_patch', 'metabridge.settings.manage',
] as const;
export type TPrivilege = typeof PRIVILEGES[number];
export const EDIT_SESSION_PRIVILEGES: readonly TPrivilege[] = [
  'metabridge.projects.edit', 'metabridge.sources.edit', 'metabridge.exploration.edit',
  'metabridge.project_dictionaries.manage', 'metabridge.model.edit', 'metabridge.versions.edit',
  'metabridge.mappings.edit', 'metabridge.datamarts.edit', 'metabridge.mdm.edit',
  'metabridge.databridge.edit', 'metabridge.comments.create', 'metabridge.comments.edit_others',
];
export const SECTION_PRIVILEGES = {
  'source-explorer': ['metabridge.sources.view', 'metabridge.sources.edit', 'metabridge.sources.run',
    'metabridge.exploration.view', 'metabridge.exploration.edit', 'metabridge.project_dictionaries.manage'],
  'business-model': ['metabridge.model.view', 'metabridge.model.edit'],
  mappings: ['metabridge.mappings.view', 'metabridge.mappings.edit'],
} as const satisfies Readonly<Record<string, readonly TPrivilege[]>>;
export type TSection = keyof typeof SECTION_PRIVILEGES;
export function hasPrivilege(grants: readonly string[], code: TPrivilege): boolean {
  return PRIVILEGES.includes(code) && grants.includes(code);
}
export function hasAllPrivileges(grants: readonly string[], codes: readonly TPrivilege[]): boolean {
  return codes.every(code => hasPrivilege(grants, code));
}
export function hasAnyPrivilege(grants: readonly string[], codes: readonly TPrivilege[]): boolean {
  return codes.some(code => hasPrivilege(grants, code));
}
export function isSection(value: unknown): value is TSection {
  return typeof value === 'string' && Object.hasOwn(SECTION_PRIVILEGES, value);
}
export function canAccessSection(grants: readonly string[], section: TSection): boolean {
  return hasAnyPrivilege(grants, SECTION_PRIVILEGES[section]);
}
